import { $http, buildHeaders } from "./index";

//员工专项附加扣除
export const essential_list = (params) => {
  return $http.get("/admin/Essential/index", { params });
};

//获取通知公告详情
export const essential_detail = (id) => {
  return $http.get("/admin/Essential/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//删除
export const essential_del = (data) => {
  return $http.post("/admin/Essential/del", data, {
    headers: buildHeaders(3),
  });
};

//从税局更新数据
export const essential_pull = (data) => {
  return $http.post("/admin/Essential/pull", data, {
    headers: buildHeaders(3),
  });
};

//获取操作记录
export const essential_log = (params) => {
  return $http.get("/admin/Essential/log", {
    params,
    headers: buildHeaders(3),
  });
};

//员工专项附加扣除
export const essential_record = (params) => {
  return $http.get("/admin/Essential/record", { params });
};

//导出
export const essential_export = (params) => {
  return $http.get("/admin/Essential/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
